let $ = require('jquery');
let Backbone = require("backbone");
let POS = require("../POS.js");
let ReserveSucView = require("./ReserveSucView.js");
let i18n = require("../utils/i18n");

let main = function () {
    var ReserveModalView = Backbone.View.extend({
        el: "#reserveModal",

        events: {
            'click .detailDay,.detailTime': 'reserveSelect',
            'click .noThanks': 'noThanks',
            'click .reserveBtn': 'reserveConsultTime',
            'mouseover .reserveBtn': 'showReserveTime',
            'mouseout .reserveBtn': 'hideReserveTime'

        },
        show: function(){
            mixpanel.track("要求预约咨询");
            this.$el.modal("show");
        },
        hide: function() {
            this.$el.modal("hide");
        },
        initialize: function (){
            this.reserveSucView = new ReserveSucView();
        },
        reserveSelect: function(e) {
            if ($(e.currentTarget).closest('span').hasClass('detailDay')) {
                $(e.currentTarget).parent().find('span').removeClass('selectActive')
                $(e.currentTarget).closest('span').addClass('selectActive')
            }
            if ($(e.currentTarget).closest('span').hasClass('detailTime')) {
                $(e.currentTarget).parent().find('span').removeClass('selectActive')
                $(e.currentTarget).closest('span').addClass('selectActive')
            }

        },
        noThanks: function(){
            this.hide();
        },

        showReserveTime: function(){
          if($('.showReserveTime').hasClass('hidden')){
              $('.showReserveTime').removeClass('hidden');
              var selectDay = this.$('.selectDay .selectActive').data('date')
              var selectTime = this.$('.selectTime .selectActive').text()
              var selectTimeMorningOrAfternoon = (parseInt(selectTime.toString().split(':')[0]) <12) ?
                  i18n.msg("pos.reserve.popup.reserve.time.morning") : i18n.msg("pos.reserve.popup.reserve.time.afternoon")
              var selectTimeHour = (parseInt(selectTime.toString().split(':')[0]) <12) ? (parseInt(selectTime.toString().split(':')[0])) : (parseInt(selectTime.toString().split(':')[0])-12)
              var selectTimeMinute = (selectTime.toString().split(':')[1] )
              var selectReserveTime = selectDay + " " + selectTimeMorningOrAfternoon + selectTimeHour + ":" + selectTimeMinute
              $('.showReserveTime').html(
                  selectReserveTime + '<img src="/images/pos/consult/consult-arrow.png" style="position: relative;left: -60px;top: 14px;">'
              )
          }
        },

        hideReserveTime: function(){
            if(!$('.showReserveTime').hasClass('hidden')){
                $('.showReserveTime').addClass('hidden')
            }
        },

        reserveConsultTime: function (){
            var selectDay = this.$('.selectDay .selectActive').data('date')
            var selectTime = this.$('.selectTime .selectActive').text()
            var selectReserveTime = selectDay + " " + selectTime
            var informWay =this.$('input:radio[name="chooseInformWay"]:checked').val();
            var telephone = this.$('.chooseInformWay .phoneInput').val();
            var reserveSucView = this.reserveSucView;
            var self = this ;
            var jxhr;
            if(informWay == 'phone' && telephone == ''){
                alert(i18n.msg("pos.reserve.popup.reserve.informWay.phone.input"));
                return
            }
            mixpanel.track("完成预约咨询");
            jxhr = $.post("/pos/sendEmailforReserveConsultTime", {selectReserveTime: selectReserveTime,
                informWay:informWay,telephone:telephone});

            jxhr.done(function (res) {
                if (res.success) {
                    reserveSucView.show();
                    self.hide();
                } else {
                    alert(i18n.msg("pos.reserve.popup.sure.fail"))
                }
            });

            jxhr.fail(function(){
                alert(i18n.msg("pos.reserve.popup.sure.fail"))
            })
        }
    });

    return ReserveModalView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/ReserveModalView.js